import React from 'react';

const AlignLeftIcon = props => (
  <svg viewBox="0 0 20 18" {...props}>
    <g stroke="none" strokeWidth="1" fillRule="evenodd">
      <g transform="translate(-175.000000, -16.000000)">
        <path
          d="M175,16 L189,16 L189,18 L175,18 L175,16 Z M175,20 L183,20 L183,22 L175,22 L175,20 Z M175,24 L183,24 L183,26 L175,26 L175,24 Z M175,28 L183,28 L183,30 L175,30 L175,28 Z M175,32 L189,32 L189,34 L175,34 L175,32 Z M185,20 L195,20 L195,30 L185,30 L185,20 Z"
          transform="translate(185.000000, 25.000000) scale(-1, 1) translate(-185.000000, -25.000000)"
        />
      </g>
    </g>
  </svg>
);

export default AlignLeftIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/align-left-icon.js